import ClientsScreen from '@/features/clients/components/clients-screen';
import { createFileRoute } from '@tanstack/react-router';
import { fallback, zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

export const clientsSearchSchema = z.object({
  search: fallback(z.string(), '').default(''),
  page: fallback(z.number(), 1).default(1),
  pageSize: fallback(z.number(), 20).default(20),
  sortBy: fallback(z.enum(['NAME', 'CITY', 'CREATED_AT']), 'NAME').default(
    'NAME',
  ),
  sortDirection: fallback(z.enum(['ASC', 'DESC']), 'ASC').default('ASC'),
  includeArchived: fallback(z.boolean(), false).default(false),
  client: fallback(z.string().optional(), undefined).optional(),
});

// Dette assumée : l'URL porte les défauts (?search=&page=1&…). Le strip via
// search.middlewares[stripSearchParams] dégrade l'inférence d'useSearch en
// `{}` avec zodValidator (router 1.170) — à reprendre à la prochaine montée
// de version du router.
export const Route = createFileRoute('/_app/clients')({
  validateSearch: zodValidator(clientsSearchSchema),
  component: ClientsScreen,
});
